import { render, staticRenderFns } from "./pacsInfo.vue?vue&type=template&id=3e2b106a&scoped=true"
import script from "./pacsInfo.vue?vue&type=script&lang=js"
export * from "./pacsInfo.vue?vue&type=script&lang=js"
import style0 from "./pacsInfo.vue?vue&type=style&index=0&id=3e2b106a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b106a",
  null
  
)

export default component.exports